(function () {
  'use strict';

  var BaseLoadPhotoswipe = window.theme && window.theme.LoadPhotoswipe;
  if (!BaseLoadPhotoswipe) return;

  var ASSET_TIMEOUT_MS = 10000;
  var IMAGE_TIMEOUT_MS = 15000;
  var OPENING_CLASS = 'pswp--custom-opening';
  var LOADER_CLASS = 'pswp--custom-loader';
  var LOADER_SELECTOR = '.pswp__loader';
  var ACTIVE_PRELOADER_SELECTOR = '.pswp__preloader--active';
  var OPTIONS_ATTRIBUTE = 'data-pswp-option-classes';
  var photoswipeAssetPromise = null;

  function hasPhotoswipeLibrary() {
    return Boolean(
      window.themePhotoswipe &&
      window.themePhotoswipe.PhotoSwipe &&
      window.themePhotoswipe.PhotoSwipe.default &&
      window.themePhotoswipe.PhotoSwipeUI &&
      window.themePhotoswipe.PhotoSwipeUI.default
    );
  }

  function loadPhotoswipeAsset(url) {
    if (hasPhotoswipeLibrary()) return Promise.resolve();
    if (photoswipeAssetPromise) return photoswipeAssetPromise;

    photoswipeAssetPromise = new Promise(function (resolve, reject) {
      var absoluteUrl = new URL(url, document.baseURI).href;
      var script = Array.prototype.find.call(document.scripts, function (candidate) {
        return candidate.src === absoluteUrl;
      });
      var createdScript = false;
      var settled = false;

      function cleanup() {
        window.clearTimeout(timeout);
        script.removeEventListener('load', handleLoad);
        script.removeEventListener('error', handleError);
      }

      function finish(callback, value) {
        if (settled) return;
        settled = true;
        cleanup();
        callback(value);
      }

      function handleLoad() {
        if (hasPhotoswipeLibrary()) {
          finish(resolve);
        } else {
          finish(reject, new Error('PhotoSwipe loaded without its expected API.'));
        }
      }

      function handleError() {
        if (createdScript && script.parentNode) script.parentNode.removeChild(script);
        finish(reject, new Error('PhotoSwipe could not be loaded.'));
      }

      var timeout = window.setTimeout(function () {
        if (createdScript && script.parentNode) script.parentNode.removeChild(script);
        finish(reject, new Error('PhotoSwipe loading timed out.'));
      }, ASSET_TIMEOUT_MS);

      if (!script) {
        script = document.createElement('script');
        script.src = absoluteUrl;
        script.async = true;
        script.setAttribute('data-hh-photoswipe-loader', '');
        createdScript = true;
      }

      script.addEventListener('load', handleLoad, { once: true });
      script.addEventListener('error', handleError, { once: true });

      if (createdScript) document.head.appendChild(script);
    }).catch(function (error) {
      photoswipeAssetPromise = null;
      throw error;
    });

    return photoswipeAssetPromise;
  }

  window.theme.LoadPhotoswipe = class extends BaseLoadPhotoswipe {
    init() {
      this.pswpElement.classList.add(OPENING_CLASS);
      this.initLoader();

      loadPhotoswipeAsset(window.theme.assets.photoswipe)
        .then(() => this.loadPopup())
        .catch((error) => this.recoverFromLoadFailure(error));
    }

    loadPopup() {
      super.loadPopup();
      if (!this.popup) return;

      this.armImageTimeout();
      this.popup.listen('beforeChange', () => this.armImageTimeout());
      this.popup.listen('imageLoadComplete', (index) => {
        if (
          typeof index !== 'number' ||
          index === this.popup.getCurrentIndex()
        ) {
          this.clearImageTimeout();
        }
      });
      this.popup.listen('close', () => this.clearImageTimeout());
    }

    armImageTimeout() {
      this.clearImageTimeout();
      this.imageLoadTimeout = window.setTimeout(() => {
        this.imageLoadTimeout = null;
        if (
          this.popup &&
          this.pswpElement.querySelector(ACTIVE_PRELOADER_SELECTOR)
        ) {
          console.error(new Error('The full-size product image timed out.'));
          this.popup.close();
        }
      }, IMAGE_TIMEOUT_MS);
    }

    clearImageTimeout() {
      if (!this.imageLoadTimeout) return;
      window.clearTimeout(this.imageLoadTimeout);
      this.imageLoadTimeout = null;
    }

    recoverFromLoadFailure(error) {
      console.error(error);
      this.clearImageTimeout();
      this.pswpElement.classList.remove(OPENING_CLASS);
      this.pswpElement.classList.add(LOADER_CLASS);
      this.pswpElement.setAttribute(OPTIONS_ATTRIBUTE, '');
      this.pswpElement.setAttribute('aria-hidden', 'true');
      this.pswpElement.querySelectorAll(LOADER_SELECTOR).forEach(function (loader) {
        loader.remove();
      });

      if (this.a11y) {
        this.a11y.removeTrapFocus();
        this.a11y.autoFocusLastElement();
      }
    }
  };
})();
